import {epos2Axios} from "@/interceptors/axios";

class UserService {
    async getUsers(serverUsersOptions) {
        try {
            let config = {
                params: {
                    userlevel: serverUsersOptions.userLevel,
                    operator: serverUsersOptions.userOperator
                },
            }

            return await epos2Axios.get('/api/users', config);

        } catch (error) {
            console.error('Error fetching data:', error);
            return {
                users: []
            };
        }
    }


}

export default new UserService();